var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.0869C1 5.1771 2.5482 3.62891 4.45799 3.62891H19.542C21.4518 3.62891 23 5.1771 23 7.0869V17.0403C23 18.9501 21.4518 20.4983 19.542 20.4983H4.45799C2.5482 20.4983 1 18.9501 1 17.0403V7.0869ZM2.52835 6.47695C2.46756 6.66942 2.43478 6.87433 2.43478 7.0869V17.0403C2.43478 18.1577 3.34061 19.0635 4.45799 19.0635H19.542C20.6594 19.0635 21.5652 18.1577 21.5652 17.0403V7.0869C21.5652 6.87205 21.5317 6.66501 21.4697 6.47074L14.2754 12.0049C13.6217 12.5078 12.8202 12.7804 11.9954 12.7804C11.1707 12.7804 10.3691 12.5078 9.71545 12.0049C9.71543 12.0049 9.71542 12.0049 9.7154 12.0049L2.52835 6.47695ZM3.41797 5.35111L10.5902 10.8677L10.5902 10.8677C10.9931 11.1776 11.4871 11.3456 11.9954 11.3456C12.5037 11.3456 12.9977 11.1776 13.4006 10.8677L13.7991 11.3858L13.4006 10.8677L20.5764 5.34773C20.2737 5.16732 19.92 5.06369 19.542 5.06369H4.45799C4.07769 5.06369 3.72189 5.16862 3.41797 5.35111Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.36f42675c308fd7d978b5b9f098f3721.svg";
export { ForwardRef as ReactComponent };